<!--
 * @Author: 孙照
 * @LastEditTime: 2023-11-22 14:11:48
 * @Description: 场站数量等数据
 * @FilePath: \sheyang\src\module\chargingStats\deviceNumber.vue
-->
<template>
  <div class="total-number">
    <div class="total-number-item">
      <span class="label">场站数量</span>
      <span class="value">{{ deviceNumber.stationNum }}</span>
    </div>
    <div class="total-number-item">
      <span class="label">终端总数</span>
      <span class="value">{{ deviceNumber.equipmentAmount }}</span>
    </div>
    <div class="total-number-item">
      <span class="label">交流枪数</span>
      <span class="value">{{ deviceNumber.ac }}</span>
    </div>
    <div class="total-number-item">
      <span class="label">直流枪数</span>
      <span class="value">{{ deviceNumber.dc }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'deviceNumber',
  props: {
    deviceNumber: {
      type: Object,
      default: () => {
        return {
          stationNum: 0,
          equipmentAmount: 0,
          ac: 0,
          dc: 0
        }
      },
    },
  }
}
</script>

<style lang="less" scoped>
.total-number {
  width: 424px;
  height: 44px;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(136, 220, 251, 0.18), rgba(113, 209, 249, 0.6), rgba(106, 206, 249, 0.18)) 1 1;
  display: grid;
  margin-bottom: 20px;
  grid-template-columns: repeat(4, 1fr);
  .total-number-item {
    height: 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .label {
      margin-bottom: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #CCCCCC;
    }
    .value {
      font-size: 16px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #FFFFFF;
    }
  }
}
</style>
